export const router_must_sign = [
    "login", "register", "recover_password", "user/set_new_password", "user/active_account", "quick-login",
    "webauthn/generate-registration-options", "webauthn/generate-authentication-options"
]